/**
 * 브라우저 내비게이션 원시 연산.
 *
 * 라우팅 라이브러리를 쓰지 않습니다 — 화면이 5개이고 중첩 라우트·로더·코드 스플릿이 없어서
 * history API 로 충분합니다(vanilla 구현도 같은 선택입니다). 이 파일은 그 API 를 한 겹 감싼
 * 것뿐인데, **감싸는 이유는 테스트**입니다: jsdom 의 `window.location.replace` 는 재정의가
 * 막혀 있어 스파이를 걸 수 없습니다. 전체 페이지 이동을 이 모듈의 함수로 모아 두면 테스트가
 * 모듈을 모킹해 "세션이 있는 위임 진입은 즉시 이동한다" 를 검증할 수 있습니다.
 */

/** SPA 내부 이동 — 히스토리에 쌓습니다(뒤로가기로 돌아올 수 있어야 하는 이동). */
export function pushPath(path: string): void {
  window.history.pushState({}, "", path);
}

/** SPA 내부 정규화 — 히스토리를 덮어씁니다(로그인→갤러리처럼 뒤로가기 루프를 만들면 안 되는 이동). */
export function replacePath(path: string): void {
  window.history.replaceState({}, "", path);
}

/**
 * 외부(다른 origin) 전체 이동 — API 의 `/auth/login` 으로 넘길 때 씁니다.
 *
 * `assign` 이 아니라 `replace` 인 이유: 이 화면은 "이동 중" 안내일 뿐이라 히스토리에 남으면
 * 서비스에서 뒤로가기를 누른 사용자가 다시 리다이렉트 루프로 들어옵니다.
 */
export function redirect(url: string): void {
  window.location.replace(url);
}

/** 현재 경로(쿼리·해시 제외). */
export const currentPath = (): string => window.location.pathname;

/** 현재 쿼리 문자열. */
export const currentSearch = (): string => window.location.search;

/** 현재 origin — 콘솔 흐름의 `return_to` 절대 URL 조립에 씁니다. */
export const currentOrigin = (): string => window.location.origin;
